module.exports = __webpack_public_path__ + "static/images/icon-facebook.bfb53449c1fdce0620ced25ef853eb7c.svg";